import './common.css';

/**
 * The only button in the app.
 *
 * `loading` keeps the label in place and swaps the icon for a spinner, so the
 * button does not resize mid-action and shift everything next to it.
 */
export function Button({
  children,
  variant = 'default',
  size = 'md',
  icon = null,
  loading = false,
  block = false,
  className = '',
  type = 'button',
  ...rest
}) {
  const classes = [
    'btn',
    variant !== 'default' && `btn--${variant}`,
    size !== 'md' && `btn--${size}`,
    block && 'btn--block',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button type={type} className={classes} disabled={loading || rest.disabled} {...rest}>
      {loading ? <span className="spinner" aria-hidden="true" /> : icon}
      {children}
    </button>
  );
}

export function IconButton({ label, icon, className = '', ...rest }) {
  return (
    <button
      type="button"
      className={`btn btn--ghost btn--icon ${className}`}
      aria-label={label}
      title={label}
      {...rest}
    >
      {icon}
    </button>
  );
}

export function CopyButton({ value, label = 'Copy', size = 'sm', ...rest }) {
  const copy = async () => {
    const text = typeof value === 'string' ? value : JSON.stringify(value, null, 2);
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      // Clipboard is unavailable outside a secure context; fall back to a selection.
      const area = document.createElement('textarea');
      area.value = text;
      document.body.appendChild(area);
      area.select();
      document.execCommand('copy');
      area.remove();
    }
  };

  return (
    <Button variant="ghost" size={size} onClick={copy} {...rest}>
      {label}
    </Button>
  );
}
